/**
 * Typed errors thrown by `ApiClient` / `authFetchWithRefresh`. Lives here
 * (services/api) so it's free of workspace-layer concerns and can be
 * caught from anywhere without a circular import.
 */

/** Thrown when the server returns 409 (conditional-write rejection). */
export class ConflictError extends Error {
  constructor() {
    super('Conflict: version mismatch')
    this.name = 'ConflictError'
  }
}

/**
 * Thrown for any non-409 non-2xx response. Carries status + path, and `body`:
 * the parsed error response (when it was JSON) so callers can read structured
 * error details (e.g. a backtest's `{detail:{node_id,reason}}`) — `undefined`
 * when the body was empty or not JSON.
 */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly path: string,
    public readonly body?: unknown,
  ) {
    super(`API ${status}: ${path}`)
    this.name = 'ApiError'
  }
}
